export default __webpack_public_path__ + "static/media/person.f21abf25.svg";